import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

function TaxpayerInformation({ data }) {
  const taxPayerFullName = `${get(data, 'attributes.first_name') || '-'} ${get(
    data,
    'attributes.middle_name'
  ) || '-'}
  ${get(data, 'attributes.last_name') || '-'} ${get(
    data,
    'attributes.extension_name'
  ) || '-'}`;

  const address = `${get(data, 'attributes.region_name') || '-'}
  ${get(data, 'attributes.province_name') || '-'} 
  ${get(data, 'attributes.municipality_name') || '-'} 
  ${get(data, 'attributes.barangay_name') || '-'} 
  ${get(data, 'attributes.street') || '-'}`;

  return (
    <div className="p-3">
      <table className="transaction-table table table-borderless table-sm">
        <tbody>
          <tr>
            <td className="text-dark" width="150">
              Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{taxPayerFullName || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              Gender
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.gender') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              Civil Status
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.civil_status') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              Birth Date
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.birth_date') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              Address
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{address || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              Email
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.email') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              TIN Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.tin_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              PAGIBIG ID Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.pagibig_id_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              Philhealth ID Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.philhealth_id_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              GSIS ID Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.gsis_id_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              Mobile Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.mobile_number') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="150">
              Telephone Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.telephone_number') || '-'}</b>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

TaxpayerInformation.defaultProps = {
  data: {},
}

TaxpayerInformation.propTypes = {
  data: PropTypes.instanceOf(Object),
};

export default TaxpayerInformation;
